import { ApolloClient, InMemoryCache } from '@apollo/client';
import typePolicies from './typePolicies';
import link from './apolloLink';

const client = token =>
  new ApolloClient({
    ssrMode: true,
    link: link({ token }),
    cache: new InMemoryCache({
      typePolicies,
    }),
  });

export default client;
